import { render, staticRenderFns } from "./Watch.vue?vue&type=template&id=e863c898&scoped=true"
import script from "./Watch.vue?vue&type=script&lang=js"
export * from "./Watch.vue?vue&type=script&lang=js"
import style0 from "./Watch.vue?vue&type=style&index=0&id=e863c898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e863c898",
  null
  
)

export default component.exports